import React from 'react'
import NavigationMenu from '../components/NavigationMenu'
import { connect } from 'react-redux'
import { type ClassificationResultData } from '../types'
import ConceptListChart from '../components/ConceptListChart'
import getLastToken from '../utils/getLastToken'

interface StateProps {
  queryResult: ClassificationResultData | null
}

type QueryResultPageProps = StateProps

/**
 * QueryResultPageComponent gets the API response data and renders a table and a bar chart using the returned data.
 * @param {any} {queryResult}:QueryResultPageProps
 * @returns {any}
 */
function QueryResultPageComponent ({ queryResult }: QueryResultPageProps): JSX.Element {
  console.dir(queryResult)

  const providerDataItems = queryResult ? Object.entries(queryResult) : []
  // print API response in console for debigging.
  console.dir(providerDataItems)

  return (
    <div className="container-fluid">
      <div className="row">
        <nav id="sidebarMenu" className="col-md-3 col-lg-2 d-md-block bg-light sidebar collapse">
          <NavigationMenu />
        </nav>

        <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
          <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
            <h1 className="h2">Lotus Rise: Grant Classifier</h1>
            <div className="btn-toolbar mb-2 mb-md-0">
              {
                /*
                  <div className="btn-group me-2">
                    <button type="button" className="btn btn-sm btn-outline-secondary">Share</button>
                    <button type="button" className="btn btn-sm btn-outline-secondary">Export</button>
                  </div>
                */
              }

              {
                /*
                  <div className="btn-group me-2">
                    <input type="file" className="form-control btn btn-sm btn-outline-secondary" id="inputGroupFile04" aria-describedby="inputGroupFileAddon04" aria-label="Upload" />
                    <button className="btn btn btn-sm btn-outline-secondary" type="button" id="inputGroupFileAddon04">Import</button>
                  </div>
                */
              }

              { /*
                              <div className="dropdown">
                              <button type="button" className="btn btn-sm btn-outline-secondary dropdown-toggle" id="dropdownExportButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                <span data-feather="file"></span>
                                Export
                              </button>
                              <ul className="dropdown-menu" aria-labelledby="dropdownExportButton1">
                                <li><a className="dropdown-item" href="#">CSV</a></li>
                                <li><a className="dropdown-item" href="#">XLSX</a></li>
                                <li><a className="dropdown-item" href="#">JSON</a></li>
                              </ul>
                            </div> */
              }

            </div>
          </div>

          {

            providerDataItems.map((providerDataItem) => <div className="provider-data-wrapper" key={providerDataItem[0]}>
              <h2 className="provider-title my-4">Provider: { providerDataItem[0] === 'openalex' ? 'OpenAlex' : 'Open AI' }</h2>
              {
                providerDataItem[1].map((providerConceptListData, i: number) => <div className="row lr-concept" key = {i}>
                <ConceptListChart data={providerConceptListData.concepts}/>
                <div className="col-md-12 col-sm-12 col-lg-7">
                  <h3>ID: { providerConceptListData.id || 'Unknown' }</h3>
                  <h4> {providerConceptListData.title} </h4>
                  <div className="table-responsive">
                    <table className="table table-striped table-sm">
                      <thead>
                        <tr>
                          <th style={{ width: '5%' }} scope="col">#</th>
                          <th style={{ width: '25%' }} scope="col">Display Name</th>
                          <th style={{ width: '5%' }} scope="col">Level</th>
                          <th style={{ width: '5%' }} scope="col">Score</th>
                          <th style={{ width: '20%' }} scope="col">Provider ID</th>
                          <th style={{ width: '20%' }} scope="col">Wikidata ID</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          providerConceptListData.concepts.map((conceptData, conceptIndex: number) => <tr key = {conceptIndex}>
                          <td> {conceptIndex + 1} </td>
                          <td> {conceptData.display_name ?? 'Missing' } </td>
                          <td> {conceptData.level} </td>
                          <td> {conceptData.score} </td>
                          <td><a href={String(conceptData.id)} target="_blank" rel="noreferrer">{conceptData.id ? getLastToken(String(conceptData.id)) : ''}</a></td>
                          <td><a href={conceptData.wikidata} target="_blank" rel="noreferrer">{conceptData.wikidata ? getLastToken(conceptData.wikidata) : ''}</a></td>
                        </tr>)
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

                )
              }
            </div>)
          }
        </main>
      </div>
    </div>
  )
}

const mapStateToProps = (state: any): any => {
  return {
    queryResult: state.classification.queryResult
  }
}

export const QueryResultPage = connect(mapStateToProps)(QueryResultPageComponent)
